import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { GoogleAuthProvider, signInWithPopup } from 'firebase/auth';
import { auth, updateLastLogin } from '../../firebase/config';
import { useAuth } from '../../context/AuthContext';
import './Login.css';
import { ModalCarga } from '../ModalCarga/ModalCarga';

export const Login = () => {
    const navigate = useNavigate();
    const { user, loading } = useAuth();
    const [error, setError] = useState(null);

    async function handleGoogleAuth() {
        const googleProvider = new GoogleAuthProvider();
        try {
            const res = await signInWithPopup(auth, googleProvider);
            const user = res.user;
            await updateLastLogin(user.uid);
        } catch (err) {
            console.error(err);
            setError('Ocurrió un error al iniciar sesión con Google.');
        }
    }

    useEffect(() => {
        if (!loading) {
            if (user) {
                if (user.processCompleted) {
                    navigate('/');
                } else {
                    navigate('/elige-usuario');
                }
            }
        }
    }, [user, loading, navigate]);

    if (loading) {
        return <ModalCarga/>;
    }

    return (
        <div className='login'>
            <div className='login-texto'>
                <h1>¡Regístrate gratis y accede a miles de prendas únicas!</h1>
                <p>
                    En eRastro agrupamos prendas de ropa de segunda mano de diferentes webs para que puedas encontrar lo que buscas, al mejor precio, de forma sencilla y rápida.
                    Descubre el verdadero potencial de nuestra plataforma. 
                    Inicia sesión y desbloquea funciones que harán tu experiencia mucho más completa:
                </p>
                <ul>
                    <li>Descubre <strong>dónde comprar</strong> los productos y accede a ellos para explorar cada detalle.</li>
                    <li>Prueba nuestro <strong>sistema de alertas</strong> para encontrar el producto que buscas (Límite de 1 alerta).</li>
                </ul>
                <h2>¿Quieres más? ¡Hazte Premium!</h2>
                <p>
                    Desbloquea las siguintes funcionalidades avanzadas que harán que ahorres tiempo y dinero:
                </p>
                <ul>
                    <li>Disfruta de nuestro <strong>sistema de alertas</strong> de productos.</li>
                    <li>Navega por la web <strong>sin anuncios</strong>.</li>
                    <li>Utiliza nuestro sistema de <strong>Inteligencia Artifical</strong> para detectar verdaderas gangas.</li>
                    <li>Selecciona tus productos favoritos y <strong>rastrea bajadas de precio</strong>.</li>
                </ul>
                <p>
                    Haz click{' '}
                    <span
                        onClick={() => navigate('/premium')}
                        style={{ color: '#007bff', textDecoration: 'underline', cursor: 'pointer' }}
                    >
                        aquí
                    </span>{' '}
                    para ver los detalles de los planes premium.
                </p>

                <p>
                    <em>¿A qué esperas? Iniciar sesión es gratis, regístrate y lleva tu experiencia al siguiente nivel.</em>
                </p>
                <div className='botones-login'>
                    <button className='boton-login' onClick={handleGoogleAuth}>
                        Iniciar Sesión / Registrarse con Google
                    </button>
                </div>
                {error && <p className="error-message">{error}</p>}
            </div>

            <img className='img-login' src="/imgs/login.jpeg" alt="chica mirando ropa en un baul" />
        </div>
    );
};
